(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-three-block-feature"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Bind once, works in storefront + theme editor preview
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-label-trigger]');
    const closeEl = e.target.closest('[data-label-close]');

    // OPEN
    if (trigger) {
      const section = trigger.closest('section[id^="nm-three-block-feature-"]');
      if (!section) return;

      const modal = section.querySelector('[data-label-modal]');
      if (!modal) return;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nm-lock-scroll');
      return;
    }

    // CLOSE
    if (closeEl) {
      const section = closeEl.closest('section[id^="nm-three-block-feature-"]');
      if (!section) return;

      const modal = section.querySelector('[data-label-modal]');
      if (!modal) return;

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nm-lock-scroll');
      return;
    }
  });

  // ESC to close (delegated)
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;

    document.querySelectorAll('section[id^="nm-three-block-feature-"] [data-label-modal].is-open')
      .forEach(modal => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('nm-lock-scroll');
      });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
